import React from 'react';
import { OverlayChildren } from 'react-bootstrap/esm/Overlay';
import { Placement } from 'react-bootstrap/esm/types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import styles from './question-info.module.scss';

interface Props {
  overlay: OverlayChildren | string;
  placement: Placement;
  width?: React.CSSProperties['width'];
  height?: React.CSSProperties['height'];
  fontSize?: React.CSSProperties['fontSize'];
}

const QuestionInfo = ({ overlay, placement, fontSize = '16px', width = '26px', height = '26px' }: Props) => {
  return (
    <div className={styles['container']}>
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement={placement}
        overlay={
          <Popover id="productItem-tooltip-popoover">
            <Popover.Body id="productItem-tooltip-popoover-body">{overlay}</Popover.Body>
          </Popover>
        }
        delay={150}
      >
        <button type="button" style={{ width, height, fontSize }}>
          <div>?</div>
        </button>
      </OverlayTrigger>
    </div>
  );
};

export default QuestionInfo;
